// features/workstations/close/script-display.js
// Renders the 12-step consultative script.

export default function ScriptDisplay({ script }) {
  if (!script || !Array.isArray(script.steps)) return null;
  return (
    <div>
      {script.steps.map((s) => (
        <div key={s.n} style={{ display: 'flex', gap: 14, padding: '12px 0', borderTop: s.n > 1 ? '1px solid var(--border-4)' : 'none' }}>
          <div style={{ flexShrink: 0, width: 26, height: 26, borderRadius: '50%', background: 'var(--surface-3)', border: '1px solid var(--border-3)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: '#c8a96e', fontWeight: 700 }}>{s.n}</div>
          <div>
            <div style={{ fontSize: 10, letterSpacing: 0.5, textTransform: 'uppercase', color: '#6a6a76' }}>{s.label}</div>
            <div style={{ fontSize: 14, marginTop: 2, lineHeight: 1.5 }}>{s.line}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
